import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    SelectChangeEvent
} from '@mui/material'

export interface Planning {
    _id: string;
    name: string;
}

interface PlanningFilterProps {
    selectedPlanningId: string | null;
    plannings: Planning[] | undefined;
    isLoading: boolean;
    onPlanningChange: (planningId: string | null) => void;
}

export function PlanningFilter({
    selectedPlanningId,
    plannings,
    isLoading,
    onPlanningChange
}: PlanningFilterProps) {
    const { t } = useTranslation();

    const handleChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        onPlanningChange(value === 'all' ? null : value);
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel id="planning-filter-label">
                {t('page.shiftMarketplace.planningFilter', 'Planning')}
            </InputLabel>
            <Select
                labelId="planning-filter-label"
                value={selectedPlanningId || 'all'}
                label={t('page.shiftMarketplace.planningFilter', 'Planning')}
                onChange={handleChange}
                disabled={isLoading}
                startAdornment={isLoading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
            >
                <MenuItem value="all">{t('page.shiftMarketplace.allPlannings', 'All Plannings')}</MenuItem>
                {plannings?.map(planning => (
                    <MenuItem key={planning._id} value={planning._id}>
                        {planning.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default PlanningFilter;
